// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subscriptionbutton-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 10px;
  height: 46px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  background: linear-gradient(91.88deg, #f541ff -2%, #6f55ff 40.2%, #109fff 71.91%, #2ed6fe 100.59%);
  color: var(--ffff);
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/SubscriptionButton/SubscriptionButton.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,kGAAA;EAOA,kBAAA;AALF","sourcesContent":["#subscriptionbutton-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  border-radius: 10px;\r\n  height: 46px;\r\n  user-select: none;\r\n  cursor: pointer;\r\n  background: linear-gradient(\r\n    91.88deg,\r\n    #f541ff -2%,\r\n    #6f55ff 40.2%,\r\n    #109fff 71.91%,\r\n    #2ed6fe 100.59%\r\n  );\r\n  color: var(--ffff);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
